/**
 * 사용할 때
 * state: state.moduleName.stateName
 * getters: computed(() => store.getters["moduleName/getterName"])
 * mutation: store.commit("moduleName/mutationName", params)
 * action은 store.dispatch("moduleName/actionName", params)
 */
 export default {
  namespaced: true,
  state: {
    user: {
      id:  "",
      name: "",
      isLogin: false
    }
  },
  getters: {
    isLogined: function(state) {
      return state.user && state.user.isLogin;
    },
    getuser: function(state) {
      return state.user
    }
  },
  mutations: {
    SAVE(state, { user}) {
      state.user.id = user.userId;
      state.user.name = user.userName;
      state.user.role = user.role;
      state.user.isLogin = true;
    },
    FLUSH(state){
      console.log("flush")
      state.user = {};
      window.localStorage.removeItem('vuex');
    }
  },
  actions: {
    flush(context){
      context.commit('FLUSH')
    },
    saveUser(context, {user}) {
      context.commit('SAVE', {user})
    },
  },
}
